import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelMealReasonMiniEntity } from '../../domain/entities/CancelMealReasonMiniEntity'
import type { CancelMealReasonAdminListedDtoAdmin } from '@/backend/market'

export class CancelMealReasonMiniModel extends CancelMealReasonMiniEntity {
  constructor(dataDto: CancelMealReasonAdminListedDtoAdmin) {
    super()
    mapEntityProperties<CancelMealReasonMiniEntity>(this, dataDto)
  }
}
